import styled from 'styled-components'

import { CenterAlignedTableDivision, TableDivision, TableRow } from './styles'
import { Box } from '../../../shared_components/UI/Box'
import { loadingPlaceholderAnimation } from '../../../theme'

const LeftMargin = styled(Box)`
  margin-left: 16px;
`

const LoadingPlaceholder = styled.div<{
  height?: number
  width?: number
  isTokenLogo?: boolean
  borderRadius?: number
}>`
  background: ${({ theme }) => theme.colors.loadingPlaceholderBG};
  overflow: hidden;
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '0')}px;
  position: relative;
  height: ${({ height }) => height ? `${height}px` : '100%'};
  width: ${({ width }) => width ? `${width}px` : '100%'};
  ${({ width }) => loadingPlaceholderAnimation(width ? 510 / width : 1)};
`

const LoadingState = () => {
  return (
    <TableRow showBorder>
      <TableDivision>
        <Box align="center">
          <LoadingPlaceholder width={56} height={56} borderRadius={0} />
          <LeftMargin direction="column">
            <LoadingPlaceholder width={88} height={10} borderRadius={100} />
            <Box marginTop={12}>
              <LoadingPlaceholder width={46} height={10} borderRadius={100} />
            </Box>
          </LeftMargin>
        </Box>
      </TableDivision>
      <TableDivision>
        <LoadingPlaceholder width={140} height={10} borderRadius={100} />
      </TableDivision>
      <TableDivision>
        <LoadingPlaceholder width={200} height={10} borderRadius={100} />
      </TableDivision>
      <CenterAlignedTableDivision>
        <Box justify="flex-end">
          <LoadingPlaceholder width={51} height={10} borderRadius={100} />
        </Box>
      </CenterAlignedTableDivision>
      <TableDivision>
        <Box justify="flex-end">
          <LoadingPlaceholder width={10} height={10} borderRadius={100} />
        </Box>
      </TableDivision>
    </TableRow>
  )
}

export default LoadingState
